import { toUnicode } from 'idna-uts46-hx';

function validatePassword(password ) {
    let res = false;
    var passwordValidator = require('password-validator');
    var schema = new passwordValidator();
    schema
    .is().min(7)                                    // Minimum length 7
    .is().max(20)                                   // Maximum length 20
    .has().uppercase()                              // Must have uppercase letters
    .has().lowercase()                              // Must have lowercase letters
    .has().digits(1)                                // Must have at least 1 digits
    .has().not().spaces();                          // Should not have spaces
    
    // Validate against a password string
    res = schema.validate(password);
    return res;
}
const globalKeys = {
    patient: "patient",
    patient_expert: "patient_expert",
    patient_prevention: "patient_prevention",
    entourage : "entourage",
    pro_standard : "pro_standard",
    pro_payeur : "pro_patient_payeur",
    pro_moderateur : "pro_moderateur",
    pro_entreprise : "pro_entreprise",
    pro_equipe : "pro_equipe",
    pro_etablissement : "pro_etablissement",
    administrateur: 'administrateur',
    dieteticienne : 'dieteticienne'
}

// ==== REGEX: Email ====
/** Common rules for an email regex */
const doubleDotGuard = `(?!.*\\.\\.)`;            // prevents consecutive dots
const startWithNoDot = `(?![.])`;                 // prevents leading dot
const endWithNoDot = `(?<![.])`;                  // prevents trailing dot
const startWithNoDash = `(?![-])`;                // prevents leading dash
const endWithNoDash = `(?<![-])`;                 // prevents trailing dash
/** Local rules */
const quote = `"((?:[^"\\\\]|\\\\.)+)"`;
/** Domain rules */
const tld = `\\.[a-zA-Z]{2,}`;
const ipV4Segment = '(25[0-5]|2[0-4]\\d|1\\d{2}|[1-9]?\\d)';
const ipDomain = `\\[${ipV4Segment}\\.${ipV4Segment}\\.${ipV4Segment}\\.${ipV4Segment}\\]`;

/**
 * Creates the local part (before the '@') of an email regex
 * @param {string} allowedChars - Character set to allow in unquoted local part
 * @returns {string} Regex string for the local part
 */
function createLocalPart({ allowedChars }) {
    const local =
        doubleDotGuard +
        startWithNoDot +
        `[${allowedChars}]+`+`(?:[.-][${allowedChars}]+)*` +
        endWithNoDot
    ;
    return `(?:${quote}|${local})`
}

/**
 * Creates the domain part (after the '@') of an email regex
 * @param {string} allowedChars - Character set to allow in domain labels
 * @returns {string} Regex string for the domain part
 */
function createDomainPart({ allowedChars }) {
    const domain =
		doubleDotGuard +
        startWithNoDot + startWithNoDash +
		`[${allowedChars}]+`+`(?:[.-][${allowedChars}]+)*` +
		endWithNoDot + endWithNoDash +
		tld
	;
    return `(?:${ipDomain}|${domain})`
}

/**
 * Configuration presets for email regex generation
 * Each preset defines the rules for the local and domain parts
 */
const emailRegexConfigs = {
    basic: {
        local: { allowedChars: `^@\\s"` },
        domain: { allowedChars: `^@\\s"\\[\\]` },
    },
    strict: {
        local: { allowedChars: `a-zA-Z0-9_+\\-` },
        domain: { allowedChars: `a-zA-Z0-9_+\\-` },
    },
};

/**
 * Creates a full email validation regex based on a given preset type
 * @param {'basic' | 'strict'} type - The configuration type to use
 * @returns {RegExp} A regular expression to validate email addresses
 * @throws Will throw an error if the preset type is not defined
 */
function createEmailRegex(type) {
    const config = emailRegexConfigs[type];
    if (!config) throw new Error(`Invalid email regex type: ${type}`);
    const local = createLocalPart(config.local);
    const domain = createDomainPart(config.domain);
    return new RegExp(`^${local}@${domain}$`, 'i');
}

const globalRegex = {
    stringRegex: /[a-zA-Zàâäéèêëìîïòôöùûü\- ]/g,
    stringWithNumbersRegex: /[0-9a-zA-Zàâäéèêëìîïòôöùûü\- ]/g,
    cityRegex: /[a-zA-Zàâäéèêëìîïòôöùûü\- ]/g,
    zipcodeRegex: /\b\d{5}\b/g,
    emailBasicFormatRegex: createEmailRegex('basic'),
    emailStrictFormatRegex: createEmailRegex('strict'),
    phoneRegex: /^\+[1-9]\d{1,14}$/, // E.164 format
    usernameRegex: /^[A-Za-z][A-Za-z0-9_]{5,29}$/,
    addresseRegex: /[0-9a-zA-Zàâäéèêëìîïòôöùûü\-, ]/g
}

const emailLabel = "L'email";
export const emailBasicFormatError = `${emailLabel} a un format incorrect.`;
const emailStrictFormatError = `${emailLabel} ne doit contenir que des lettres, chiffres et les caractères spéciaux suivants: _+.-`;

/**
 * Returns an appropriate error message based on email format validation
 * 
 * @param email - The email to be tested
 * @returns The error message
 */
export function getEmailRegexError (email)  {
    const emailLower = email.toLowerCase();

    const [local, domain] = emailLower.split("@");
    if (!local || !domain) {
    return emailBasicFormatError;
    }
    const emailLowerUnicode = `${local}@${toUnicode(domain)}`;

    if (!globalRegex.emailBasicFormatRegex.test(emailLowerUnicode)) {
    return emailBasicFormatError;
    }
    if (!globalRegex.emailStrictFormatRegex.test(emailLowerUnicode)) {
    return emailStrictFormatError;
    }
    return "";
}

/** Pluralize a word based on a count */
const pluralize = (word, count) => (count > 1 ? `${word}s` : word);

export {
    validatePassword,
    globalKeys,
    globalRegex,
    pluralize
}